module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Herrenmoos","short_name":"Die Band","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"standalone","icon":"src/assets/images/icons/favicon_lehmanski.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7ae593ab059b77f13dce24816f528925"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
